export const AdminIntentionalDashboards = {
  AdminIntentionalDashboards: {
    permissionsId: "ff9163cb-d061-4230-ee44-08da65738802",
    permissionsName: "Admin Intentional",
    componentsId: null,
    components: null,
  },
};
